var map = {
	"./de/text-follow-us.png": "VCZD",
	"./en/text-follow-us.png": "GyoV",
	"./es/text-follow-us.png": "AQui",
	"./fr/text-follow-us.png": "qiMo",
	"./ja/text-follow-us.png": "RssG",
	"./ko/text-follow-us.png": "NFWs",
	"./pt/text-follow-us.png": "x1sb",
	"./ru/text-follow-us.png": "vGpt",
	"./th/text-follow-us.png": "0LWy",
	"./zh-Hant/text-follow-us.png": "vIR5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "OLuz";